<div *ngIf="trip" class="trip-detail" id="mach-core-trip-detail-container">
  <div
    class="trip-detail__container flex flex-col gap-[16px] laptop:gap-0 laptop:flex-row laptop:items-center min-w-[343px] tablet:min-w-[736px] laptop:min-w-[944px] ultrawide:min-w-[1152px]"
    id="mach-core-trip-detail-wrapper"
  >
    <!-- Left Section: Title + Location + IROP Message -->
    <div
      class="trip-detail__info flex flex-1 flex-col bg-surface-02 rounded-03 p-16 laptop:bg-transparent laptop:rounded-none laptop:p-0"
      id="mach-core-trip-detail-info"
    >
      <span
        class="trip-detail__title text-label-sm-medium tablet:text-label-md-medium text-subtle mb-[4px] laptop:mb-[2px]"
      >
        {{ trip.title }}
      </span>
      <div
        class="trip-detail__header flex flex-col tablet:flex-row tablet:items-center tablet:justify-between laptop:justify-start mb-[4px] laptop:mb-[2px]"
      >
        <div
          class="trip-detail__location-wrapper flex items-center gap-8 laptop:mr-[32px] whitespace-nowrap"
        >
          <svg
            *ngIf="trip.irop?.hasMessage"
            class="trip-detail__irop-icon ultrawide:mt-[4px]"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="9.375" fill="#C01933" />
            <path
              d="M9.03415 15.625H10.9846V13.4507H9.03415V15.625Z"
              fill="white"
            />
            <path
              d="M9.38588 11.6428H10.6009L11.0806 4.375H8.90625C8.90625 4.375 9.44983 11.323 9.38588 11.6428Z"
              fill="white"
            />
          </svg>
          <div
            class="trip-detail__location text-label-xl-semibold laptop:text-heading-sm text-heading"
          >
            <span *ngIf="trip.location.secondary">
              {{ trip.location.secondary }}
            </span>
            {{ trip.location.primary }}
          </div>
        </div>
        <div
          class="trip-detail__date text-label-md-semibold text-heading whitespace-nowrap hidden tablet:block"
        >
          {{ trip.dateRange }}
        </div>
      </div>
      <div
        *ngIf="trip.irop?.hasMessage"
        class="trip-detail__irop-message text-label-xs-medium tablet:text-label-sm-medium text-body-copy"
      >
        {{ trip.irop?.message }}
      </div>
      <div
        class="trip-detail__date text-label-sm-semibold tablet:text-label-md-semibold text-heading whitespace-nowrap tablet:hidden mt-[4px]"
      >
        {{ trip.dateRange }}
      </div>
      <div
        class="trip-detail__date text-label-md-semibold text-heading whitespace-nowrap hidden"
      >
        {{ trip.dateRange }}
      </div>
    </div>

    <!-- Right: Action Buttons -->
    <div
      [ngClass]="{
        'justify-end ultrawide:pr-[4px]': trip.checkinStatus?.isEligible
      }"
      class="trip-detail__actions flex flex-col laptop:flex-row gap-[16px] w-full laptop:w-auto items-stretch laptop:items-center"
      id="mach-core-trip-detail-actions"
    >
      <button
        type="button"
        class="trip-detail__button laptop:w-[195px]"
        [class]="
          trip.checkinStatus?.isEligible
            ? 'button button-secondary button-lg'
            : 'button button-primary button-lg'
        "
        (click)="viewTripDetails()"
        id="mach-core-trip-detail-view-button"
      >
        {{ trip.content.viewTripDetailsTitle }}
      </button>

      <ng-container *ngIf="trip.checkinStatus?.isEligible">
        <button
          type="button"
          class="trip-detail__button button button-primary button-lg laptop:w-[195px]"
          *ngIf="!trip.checkinStatus?.isCheckedIn"
          (click)="checkIn()"
          id="mach-core-trip-detail-checkin-button"
        >
          {{ trip.content.checkInTitle }}
        </button>

        <button
          type="button"
          class="trip-detail__button button button-primary button-lg"
          *ngIf="trip.checkinStatus?.isCheckedIn"
          (click)="checkIn()"
          id="mach-core-trip-detail-boarding-pass-button"
        >
          {{ trip.content.viewBoardingPassTitle }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
